import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import "./SliderBox.css";

export const SliderBox = ({
  onSubmit,
  onClearError,
  errorMessage,
}: {
  onSubmit: (code: string) => void;
  onClearError?: () => void;
  errorMessage?: string;
}) => {
  const { t } = useTranslation();

  const [sliderValue, setSliderValue] = useState(0);
  const [code, setCode] = useState("");
  const [showSpecialBox, setShowSpecialBox] = useState(false);

  const handleSlider = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    setSliderValue(value);
  };

  const handleRelease = () => {
    if (sliderValue < 50) {
      setSliderValue(0);
      setShowSpecialBox(false);
      setCode("");
      if (errorMessage && onClearError) onClearError();
    } else {
      setSliderValue(100);
      setShowSpecialBox(true);
    }
  };

  return (
    <Box sx={{ maxWidth: 340, mx: "auto", mt: 2, textAlign: "center" }}>
      <Typography sx={{ fontSize: 15, color: "#444", mb: 1, fontWeight: 500 }}>
        {t("swipe_to_unlock_special_code")}
      </Typography>

      <input
        type="range"
        min="0"
        max="100"
        value={sliderValue}
        onChange={handleSlider}
        onMouseUp={handleRelease}
        onTouchEnd={handleRelease}
        className="slider-input"
        style={{
          WebkitAppearance: "none",
          width: 200,
          height: 40,
          borderRadius: 30,
          outline: "none",
          display: "block",
          margin: "0 auto",
          boxShadow: "inset 0 2px 4px rgba(0,0,0,0.15)",
          transition: "background 0.3s ease",
          background: showSpecialBox ? "#2865d7" : "#e5e5e5",
        }}
      />

      {/* Special Input Box */}
      {showSpecialBox && (
        <Box sx={{ mt: 2 }}>
          <input
            type="text"
            placeholder={t("enter_special_code")}
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              if (errorMessage && onClearError) onClearError();
            }}
            style={{
              fontSize: 16,
              padding: 8,
              width: "75%",
              marginBottom: 9,
              border: "1px solid #bbb",
              borderRadius: 8,
              outline: "none",
              marginRight: 8,
            }}
          />

          <button
            onClick={() => onSubmit(code)}
            style={{
              fontSize: 16,
              background: "#2865d7",
              color: "#fff",
              border: "none",
              padding: "7px 20px",
              borderRadius: 8,
              cursor: "pointer",
              fontWeight: 500,
              boxShadow: "0 2px 7px rgba(40,101,215,0.12)",
            }}
          >
            {t("submit")}
          </button>
        </Box>
      )}
      {/* Error message */}
      {errorMessage && (
        <Typography sx={{ color: "red", fontSize: 14, mt: 1 }}>
          {t(errorMessage)}
        </Typography>
      )}
    </Box>
  );
};
